import { createContext, useContext } from 'react'
import { ProseStateContextValue, ProseStateProviderProps } from './ProseStateContextTypes'

const ProseStateContext = createContext<ProseStateContextValue | undefined>(undefined)

const ProseStateContextProvider = ProseStateContext.Provider

export const ProseStateProvider = ({ children, state }: ProseStateProviderProps) => {
  return <ProseStateContextProvider value={state}>{children}</ProseStateContextProvider>
}

export const useProseStateContext = () => {
  return useContext(ProseStateContext)
}
